import type * as React from 'react'

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge class names, resolving Tailwind utility conflicts (caller wins). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Drop undefined entries from a style object. React applies styles
 * key-by-key; an explicit `rowGap: undefined` after `gap` writes '' to the
 * row-gap longhand and wipes the shorthand, so undefined keys must not be
 * passed at all.
 */
export function definedStyles(
  style: Record<string, unknown>,
): React.CSSProperties {
  return Object.fromEntries(
    Object.entries(style).filter(([, v]) => v !== undefined),
  ) as React.CSSProperties
}
